import { render, staticRenderFns } from "./SavedPlanCompletedUnitCard.vue?vue&type=template&id=449624ae&"
import script from "./SavedPlanCompletedUnitCard.vue?vue&type=script&lang=js&"
export * from "./SavedPlanCompletedUnitCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports